import { useToast, POSITION  } from "vue-toastification";

const toast = useToast()

const setAudio = (type=false) => {
    let src = require('@/assets/audio/success.mp3');
    if(type === 'warning')  src = require('@/assets/audio/notification.ogg')
    if(type === 'info')  src = require('@/assets/audio/notification.ogg')
    if(type === 'error')  src = require('@/assets/audio/error.mp3')
    return new Audio(src).play()
}


const setData = (data) => {
    let config = {
        message: 'Success',
        options: {
            position: POSITION.BOTTOM_RIGHT 
        }
    }
    if (typeof data === 'string') config.message = data

    if(typeof data === 'object'){ 

        let positions = {
            topLeft: POSITION.TOP_LEFT,
            topRight: POSITION.TOP_RIGHT,
            bottomLeft: POSITION.BOTTOM_LEFT,
            bottomRight: POSITION.BOTTOM_RIGHT,
            topCenter: POSITION.TOP_CENTER,
            bottomCenter: POSITION.BOTTOM_CENTER,

        }
        config.message = data?.message
        if(data?.position){
            let position = Object.keys(positions).filter( position => position === data?.position )
            config.options.position =  positions[position] || config.options.position
        }

        
    } 

    return config;
}

function success(data, sound=false) {
    let config = setData(data)
    toast.success(config.message, config.options)
    if(sound) setAudio('success')
    return
}

function error(data, sound=false) {
    let config = setData(data)
    toast.error(config.message, config.options)
    if(sound) setAudio('error')
    return
}
function warning(data, sound=false) {
    let config = setData(data)
    toast.warning(config.message, config.options)
    if(sound) setAudio('warning')
    return
}
function info(data, sound=false) {
    let config = setData(data)
    toast.info(config.message, config.options)
    if(sound) setAudio('info')
    return
}




export default {
    success,
    error,
    info,
    warning
};